import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Insurance from './pages/categories/Insurance';
import Banking from './pages/categories/Banking';
import OtherServices from './pages/categories/OtherServices';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/other-services" element={<OtherServices />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;